<template>
  <div style="position:relative; height:280px;">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto'

export default {
  name: 'DashboardMonthlyChart',
  props: {
    monthly: { type: Array, default: () => [] },
  },
  data() {
    return { chart: null }
  },
  watch: {
    monthly: {
      deep: true,
      handler() { this.render() },
    },
  },
  mounted() {
    this.render()
  },
  beforeDestroy() {
    if (this.chart) this.chart.destroy()
  },
  methods: {
    render() {
      if (this.chart) { this.chart.destroy(); this.chart = null }
      if (!this.$refs.canvas) return
      const labels = this.monthly.map(m => m.month)
      const counts = this.monthly.map(m => m.count)
      const values = this.monthly.map(m => m.value)
      this.chart = new Chart(this.$refs.canvas.getContext('2d'), {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              type: 'bar',
              label: 'Պայմանագրեր (հատ)',
              data: counts,
              backgroundColor: 'rgba(52, 143, 226, 0.6)',
              yAxisID: 'y',
            },
            {
              type: 'line',
              label: 'Գումար (դր.)',
              data: values,
              borderColor: '#28a745',
              backgroundColor: 'rgba(40, 167, 69, 0.15)',
              yAxisID: 'y1',
              tension: 0.3,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: { mode: 'index', intersect: false },
          scales: {
            y: { position: 'left', beginAtZero: true, title: { display: true, text: 'Հատ' } },
            y1: { position: 'right', beginAtZero: true, grid: { drawOnChartArea: false }, title: { display: true, text: 'Դր.' } },
          },
        },
      })
    },
  },
}
</script>
